import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { CompanyUserService } from 'src/app/settings/services/company-user.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import constants from 'src/app/shared/constants';
import { CompanyModel } from '../../models/company-model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-company-picker',
  templateUrl: './admin-company-picker.html',
  styleUrls: ['./admin-company-picker.scss'],
})
export class AdminCompanyPickerComponent implements OnInit {
  loading: boolean = false;

  companies: CompanyModel[] = [];

  filterValue: string = '';

  selectedCompanyId: string | null = null;

  filterControl = new FormControl('');

  expanded: boolean = false;

  get filteredCompanies() {
    const term = (this.filterValue || '').toString().toLowerCase().trim();

    if (!term) return this.companies;

    return this.companies.filter((c) => c.name.toLowerCase().includes(term));
  }

  constructor(
    public dialogRef: MatDialogRef<AdminCompanyPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { companyId?: string },
    private readonly authService: AuthService,
    private readonly toastrService: ToastrService,
    private readonly translateService: TranslateService
  ) {}

  async ngOnInit(): Promise<void> {
    this.loading = true;

    this.companies = this.authService.getCompanies();

    this.loading = false;
  }

  onClose() {
    this.dialogRef.close({ companyId: this.selectedCompanyId });
  }

  onCompanySelect(company: CompanyModel) {
    this.selectedCompanyId = company._id;
    this.filterValue = company.name;
  }

  applyFilter(filterValue: string) {
    if (filterValue === '') {
      this.filterValue = '';
      this.filterControl.setValue('');
      this.selectedCompanyId = null;
      return;
    }

    this.filterValue = filterValue;
    this.filterControl.setValue(filterValue);
  }

  onConfirm() {
    if (!this.selectedCompanyId) return;

    localStorage.setItem(constants.companyIdChosenByAdmin, this.selectedCompanyId);

    this.toastrService.success(
      this.translateService.instant('AppCompanyPicker.CompanySelected'),
      this.translateService.instant('AppCompanyPicker.Saved'),
      {
        timeOut: 2_000,
        disableTimeOut: false,
        closeButton: true,
        easing: 'ease',
        easeTime: 300,
        tapToDismiss: true,
      }
    );

    this.dialogRef.close({ status: 'confirmed', companyId: this.selectedCompanyId });
  }

  isEmpty(v: string) {
    return v === '' || v === null || v === undefined;
  }

  isSelected() {
    return this.isEmpty(this.selectedCompanyId);
  }

  async logout() {
    await this.authService.closeServerSession();
    this.authService.logout();
    this.onClose();
  }

  toggleOptions() {
    this.expanded = !this.expanded;
  }
}
